export default __webpack_public_path__ + "static/sponsor@2x-731195b72aa4d16913d461257573fa3c.png";